import React from 'react';

const SectionWithImageLeft = ({ sectionTitle, title, spanTitle, description, image }) => {
  return (
    <section className="bg-slate-100 dark:bg-gray-950 py-14">
      <div className="container mx-auto flex flex-col lg:flex-row items-center px-6 lg:px-20">
        
        {/* Illustration de la bannière */}
        <div className="lg:w-1/2 w-full h-auto mr-14 px-4">
          <img
            src={image}
            alt={sectionTitle}
            className="w-full h-auto object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Texte de la bannière */}
        <div className="lg:w-1/2 text-center lg:text-left mb-10 lg:mb-0">
          <h6 className="text-xl font-bold text-blue-600 mb-4">{sectionTitle}</h6>
          <h1 className="text-5xl font-bold text-gray-800 dark:text-gray-200 mb-4">
            {title} <span className="text-blue-600">{spanTitle}</span>
          </h1>
          <p className="text-gray-600 dark:text-gray-400 text-lg mb-6">
            {description}
          </p>

          {/* Bouton intégré */}
          <a
            href="#contact"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition duration-300"
          >
            Contactez-nous
          </a>
        </div>
      </div>
    </section>
  );
};

export default SectionWithImageLeft;
